export const DEFAULT_EDITOR_CONTENT = [
  {
    children: [{ text: "" }],
    type: "paragraph",
  },
];
